import React from "react";
import VoidSVG from "./assets/void.svg";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-boundary">
          <h1 className="neonText">
            💥 Something went wrong!!. 💥
            <br />
            🙏🏻 Sorry for the inconvenience caused. 🙏🏻
            <br />
            Kindly try again after sometime ⏳ or refresh 🔄.
          </h1>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
